import { useCallback } from 'react';
import { posthogTrackEvent, GeneralEvents } from '../assets/posthog';

export const useFormTracking = () => {
  const trackFormSubmit = useCallback((formName: string, properties?: Record<string, any>) => {
    posthogTrackEvent({
      event: GeneralEvents.FORM_SUBMIT,
      properties: {
        formName,
        timestamp: new Date().toISOString(),
        ...(properties || {}),
      },
    });
  }, []);

  const trackSearch = useCallback((searchTerm: string, context?: string, properties?: Record<string, any>) => {
    posthogTrackEvent({
      event: GeneralEvents.SEARCH,
      properties: {
        searchTerm,
        context,
        searchLength: searchTerm.length,
        hasResults: properties?.hasResults,
        resultsCount: properties?.resultsCount,
        timestamp: new Date().toISOString(),
        ...(properties || {}),
      },
    });
  }, []);

  const trackFilterApplied = useCallback((filterType: string, filterValue: any, properties?: Record<string, any>) => {
    posthogTrackEvent({
      event: GeneralEvents.FILTER_APPLIED,
      properties: {
        filterType,
        filterValue,
        timestamp: new Date().toISOString(),
        ...(properties || {}),
      },
    });
  }, []);

  const trackModalOpen = useCallback((modalName: string, properties?: Record<string, any>) => {
    posthogTrackEvent({
      event: GeneralEvents.MODAL_OPEN,
      properties: {
        modalName,
        timestamp: new Date().toISOString(),
        ...(properties || {}),
      },
    });
  }, []);

  const trackModalClose = useCallback((modalName: string, properties?: Record<string, any>) => {
    posthogTrackEvent({
      event: GeneralEvents.MODAL_CLOSE,
      properties: {
        modalName,
        timestamp: new Date().toISOString(),
        ...(properties || {}),
      },
    });
  }, []);

  const trackDataExport = useCallback((exportType: string, dataType: string, properties?: Record<string, any>) => {
    posthogTrackEvent({
      event: GeneralEvents.EXPORT_DATA,
      properties: {
        exportType,
        dataType,
        timestamp: new Date().toISOString(),
        ...(properties || {}),
      },
    });
  }, []);

  return {
    trackFormSubmit,
    trackSearch,
    trackFilterApplied,
    trackModalOpen,
    trackModalClose,
    trackDataExport,
  };
};